/*
  * Rollup Common Library for JS applications
  * {@link https://github.com/united-finance/lib-js}
  * {@link https://unitedfinance.io/}
  * @copyright United Finance (@ivn703619)
  * @license MIT
  */
import Vue from'vue';import Vuex from'vuex';import {config,types}from'@uf-libjs/services';var script = {
  name: 'App',
  props: {
    component: {
      type: Object,
      default: undefined
    },
    componentProps: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.component, _vm._b({
    tag: "component",
    class: _vm.$style.box
  }, 'component', _vm.componentProps, false));
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-50f20b37_0", {
    source: "body,html{padding:0;margin:0;box-sizing:border-box}*{box-sizing:border-box}a{text-decoration:none}ul{list-style:none;padding:0;margin:0}:root{--color-primary:#000;--color-info:#555;--color-error:#E63640;--color-light:#FFF;--color-light-dim:#F1F1F1;--color-light-dim-second:#EFEFEF;--color-light-dim-third:#E0E0E0;--color-active:#15FF81;--color-header:#4C4C4C;--color-description:#4D4D55;--color-description-secondary:#6E6E6E;--color-comment:#B8B8B8;--background-color-primary:#FFFFFF;--background-color-secondary:#F9F9F9;--background-color-third:#2F2F3B;--background-color-active:#58EC9C;--background-color-black:#000;--background-color-primary-hover:#E2F9ED;--box-shadow-color-primary:rgba(32,31,39,0.10196);--scrollbar-track-background-color:#000;--scrollbar-thumb-background-color:#c4c4c4;--scrollbar-thumb-border-color:#000;--border-color-primary:#555555;--border-color-secondary:#B3BAD2;--border-color-active:#10C161;--input-background-color:#EFEFEF;--input-background-color-disabled:#C4C4C4;--input-font-color-primary:#000;--input-font-color-placeholder:#A0A7BB;--input-font-color-disabled:#828282;--input-border-color-hover:#C3C6D0;--input-border-color-active:#10C161;--button-background-color-standard:#69B3E7;--button-background-color-success:#10C161;--button-background-color-enter:#15FF81;--button-background-color-enter-secondary:#201F27;--button-background-color-stub:#BBB;--button-background-color-dark:#282828;--button-background-color-standard-disabled:#C4C4C4;--button-background-color-success-disabled:#C4C4C4;--button-background-color-standard-active:#69B3E7;--button-background-color-success-active:#10C161;--button-font-color-standard:#FFF;--button-font-color-success:#FFF;--button-font-color-enter:#000000;--button-font-color-enter-secondary:#F9F9F9;--button-font-color-stub:#FFF;--loader-color-standard:#10C161;--menu-font-primary:#FFF;--menu-font-secondary:#F5F5F5;--menu-font-active:#10C161;--menu-background-color-primary:#4B505E;--menu-background-color-secondary:#201F27;--menu-background-color-third:#1A1A1A;--menu-background-color-primary-hover:#10C161;--slider-dots-border-color:#A9A9A9;--slider-dots-background-color-checked:#201F27;--slider-dots-background-color-unchecked:#FFF;--line-color-primary:#5D5D5D;--line-color-secondary:#FFF;--progress-bar-active:#15FF81}:root.dark-theme{--background-color-primary:#2C2C2C}*{scrollbar-width:thin;scrollbar-color:#c4c4c4 #000;scrollbar-color:var(--scrollbar-thumb-background-color) var(--scrollbar-track-background-color)}::-webkit-scrollbar{width:7px}::-webkit-scrollbar-track{background:#000;background:var(--scrollbar-track-background-color)}::-webkit-scrollbar-thumb{background:#c4c4c4;background:var(--scrollbar-thumb-background-color);border:0 solid #000;border:0 solid var(--scrollbar-thumb-border-color);border-radius:10px}",
    map: undefined,
    media: undefined
  }), inject("data-v-50f20b37_1", {
    source: ".src-lib-components-box-2btC{color:var(--color-primary);font:var(--f-16);--f-11-mlsh:normal 11px/14px \"Mulish\",sans-serif;--f-b11-mlsh:bold 11px/14px \"Mulish\",sans-serif;--f-12-mlsh:normal 12px/16px \"Mulish\",sans-serif;--f-b12-mlsh:bold 12px/16px \"Mulish\",sans-serif;--f-14-mlsh:normal 14px/20px \"Mulish\",sans-serif;--f-b14-mlsh:bold 14px/20px \"Mulish\",sans-serif;--f-16-mlsh:normal 16px/24px \"Mulish\",sans-serif;--f-sb16-mlsh:600 16px/24px \"Mulish\",sans-serif;--f-b16-mlsh:bold 16px/24px \"Mulish\",sans-serif;--f-18-mlsh:normal 18px/24px \"Mulish\",sans-serif;--f-b18-mlsh:bold 18px/24px \"Mulish\",sans-serif;--f-20-mlsh:normal 20px/28px \"Mulish\",sans-serif;--f-b20-mlsh:bold 20px/28px \"Mulish\",sans-serif;--f-24-mlsh:normal 24px/32px \"Mulish\",sans-serif;--f-24i-mlsh:italic normal 24px/32px \"Mulish\",sans-serif;--f-b24-mlsh:bold 24px/32px \"Mulish\",sans-serif;--f-32-mlsh:normal 32px/40px \"Mulish\",sans-serif;--f-b32-mlsh:bold 32px/40px \"Mulish\",sans-serif;--f-32i-mlsh:italic normal 32px/40px \"Mulish\",sans-serif;--f-b32i-mlsh:italic bold 32px/40px \"Mulish\",sans-serif;--f-40-mlsh:normal 40px/48px \"Mulish\",sans-serif;--f-b40-mlsh:bold 40px/48px \"Mulish\",sans-serif;--f-40i-mlsh:italic normal 40px/48px \"Mulish\",sans-serif;--f-b40i-mlsh:italic bold 40px/48px \"Mulish\",sans-serif;--f-48-mlsh:normal 48px/56px \"Mulish\",sans-serif;--f-b48-mlsh:bold 48px/56px \"Mulish\",sans-serif;--f-48i-mlsh:italic normal 48px/56px \"Mulish\",sans-serif;--f-b48i-mlsh:italic bold 48px/56px \"Mulish\",sans-serif;--br-medium:32px;--br-small:16px;--br-tiny:12px;--br-micro:8px;--br-nano:4px;--bs-pane:0px 4px 16px 0px var(--box-shadow-color-primary);--bs-select:0px 16px 24px 0px rgba(0, 0, 0, 0.25);--ln-gr-dark:linear-gradient(111deg, rgba(163, 163, 163, 0.30) -1.56%, rgba(61, 61, 61, 0.31) 100.53%)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-lib-components-box-2btC"
    }
  }), inject("data-v-50f20b37_2", {
    source: "html{font-family:Mulish,sans-serif}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var App = __vue_component__;function initializeEnv(_ref) {
  let {
    targetId,
    configEnv,
    component,
    props,
    storeModules,
    enableStore
  } = _ref;
  if (configEnv) {
    config.env = configEnv;
  }
  Vue.config.productionTip = false;
  const currentConfig = config.current;
  if (config) {
    Vue.prototype.$config = currentConfig;
  }
  const propsObj = props ? {
    ...props
  } : {};
  let settingsVue = {
    render: h => h(App, {
      props: {
        component,
        componentProps: propsObj
      }
    })
  };
  if (!!enableStore || !!storeModules) {
    Vue.use(Vuex);
    const store = new Vuex.Store({
      modules: types.isFunction(storeModules) ? storeModules({
        Vue
      }) : storeModules
    });
    store.$set = Vue.set;
    store.$delete = Vue.delete;
    if (currentConfig) {
      store.$config = currentConfig;
    }
    settingsVue = {
      store,
      ...settingsVue
    };
  }
  new Vue(settingsVue).$mount(targetId);
}export{App,initializeEnv};